import { useState, useEffect, useRef, RefObject } from 'react';

type UseModalHeightResult = {
    height: string;
    contentRef: RefObject<HTMLDivElement>;
};

export function useModalHeight(): UseModalHeightResult {
    const [height, setHeight] = useState<string>("");
    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const updateHeight = () => {
            const headerEl = document.querySelector('.drag-bar-wrapper') as HTMLElement | null;
            const headerHeight = headerEl?.offsetHeight || 0;
            const windowHeight = window.visualViewport?.height || window.innerHeight;
            let newHeight = windowHeight - headerHeight;
            setHeight(`${newHeight}px`);
        };

        const observer = new ResizeObserver(updateHeight);

        if (contentRef.current) {
            updateHeight();
            window.addEventListener('resize', updateHeight);
            observer.observe(contentRef.current);
        }

        return () => {
            window.removeEventListener('resize', updateHeight);
            observer.disconnect();
        };
    }, []);

    return { height, contentRef: contentRef as RefObject<HTMLDivElement> };
};
